<template>
  <v-card flat>
    <v-expansion-panels
      v-model="panel"
      :disabled="$attrs.disabled"
      class="px-3"
      v-bind="$attrs"
    >
      <v-expansion-panel
        v-for="(gallery, i) in gallerys.gallery"
        :key="i"
        class="my-1"
      >
        <v-expansion-panel-header class="text-right">
          <div class="d-flex align-items-center">
            <v-icon
              @click.stop="deleteItems(i, gallery.name)"
              v-if="!chose[i]?.loading"
              >mdi-delete</v-icon
            >

            <v-text-field
              @click.stop=""
              v-if="chose[i]?.loading"
              v-model="chose[i].item.name"
              dense
              append-icon="mdi-check"
              prepend-inner-icon="mdi-close"
              @click:append.stop="
                gallery.name = chose[i].item.name;
                chose[i].loading = false;
              "
              @click:prepend-inner.stop="
                chose[i].item.name = gallery.name;
                chose[i].loading = false;
              "
              outlined
              class="pa-0"
              hide-spin-buttons
              hide-details
              style="max-width: 200px !important"
            />

            <v-card-title v-else class="pa-1">
              {{ gallery.name }}
              <v-icon
                @click.stop="chose[i].loading = true"
                class="mr-2"
                size="20"
                >mdi-pencil</v-icon
              >
            </v-card-title>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="text-right">
          <voice-gallery v-model="gallery.audiosGallery" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card-actions class="mt-5">
      <v-btn @click="addGallery" color="green" outlined class="w-100">
        <v-icon>mdi-plus</v-icon>
        {{ $t('add_voice_gallery') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import voiceGallery from "../index.vue";
export default {
  name: "voiceGalleryAcc",

  components: { voiceGallery },

  props: {
    value: [Object],
  },

  data() {
    return {
      panel: [],
      chose: {},
    };
  },

  computed: {
    gallerys: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  mounted() {
    this.choseSet();
  },

  methods: {
    addGallery() {
      this.gallerys.gallery.push({
        name: `${this.$t('gallery_number')} ${this.gallerys?.gallery?.length + 1}`,
        audiosGallery: { audios: [], audioType: "newPlayer" },
      });
      this.choseSet();
    },
    choseSet() {
      let gallery = JSON.parse(JSON.stringify(this.value.gallery));
      gallery.map((item, index) => {
        this.chose = { ...this.chose, [index]: { loading: false, item: item } };
      });
    },
    async deleteItems(id, title) {
      if (await this.$modal.yesNo(`${this.$t('delete_confirm')}  ${title}  ${this.$t('confirm')}`)) {
        this.gallerys.gallery = this.gallerys.gallery.filter(
          (_, index) => index !== id
        );
        this.choseSet();
      }
    },
  },
};
</script>
<style scoped>
.v-expansion-panel:not(.single) {
  border-radius: 15px !important;
}

.v-expansion-panel:not(.single)
  >>> .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #001554 !important;
  border-radius: 15px !important;
  color: whitesmoke !important;
}

.v-expansion-panel:not(.single)
  >>> .v-expansion-panel-header.v-expansion-panel-header--active
  .v-icon {
  color: whitesmoke !important;
}

.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}

@media screen and (max-width: 600px) {
  .list-expansion >>> .v-expansion-panel-content__wrap {
    padding: 0 4px !important;
  }
}
</style>
